// extracted by mini-css-extract-plugin
export default {"centered":"LoadingSpinner_centered__25p+P"};